import React from 'react';
import FilterBar from '../../components/filters/FilterBar';
import { BadgeMetrics, PhoneAuthMetrics } from '../../components/dashboard/metrics';
import PageLayout from '../../components/layout/PageLayout';
import ErrorBoundary from '../../components/ui/ErrorBoundary';
import { useFilterPersistence } from '../../hooks/useFilterPersistence';
import { useSettings } from '../../contexts/SettingsContext';
import { PAGE_INFO, FILTER_PERIODS } from '../../constants';
import './Badges.css';

/**
 * Badges Page Component
 * Badge system and user achievements
 */
const Badges = () => {
  const { period, setPeriod } = useFilterPersistence({
    pageKey: 'badges',
    defaultPeriod: FILTER_PERIODS.ALL
  });
  const settings = useSettings();
  const compact = settings.compactMode;

  const filters = (
    <FilterBar
      period={period}
      onPeriodChange={setPeriod}
    />
  );

  return (
    <ErrorBoundary>
      <PageLayout
        title={PAGE_INFO.BADGES.title}
        description={PAGE_INFO.BADGES.description}
        filters={filters}
      >
        <div className="badges-content">
          <div className="badges-grid">
            <BadgeMetrics period={period} compact={compact} />
            <PhoneAuthMetrics period={period} compact={compact} />
          </div>
        </div>
      </PageLayout>
    </ErrorBoundary>
  );
};

export default Badges;

